import React from "react";
import { MenuItem, styled } from "@mui/material";

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  backgroundColor: theme.palette.common.grey.g474a53,
  "&.Mui-selected": {
    backgroundColor: theme.palette.background.paper,
  },
}));

export default StyledMenuItem;
